export default function postCustomSSLCertificatesReducer
  (state = { error:'', success:'', processing:false}, action)
{
  switch (action.type) {
    case 'POST_CUSTOM_SSL_CERTIFICATES_SUCCESS':
      return {...state, ...{success: action.success}};

    case 'POST_CUSTOM_SSL_CERTIFICATES_ERROR':
      return {...state, ...{error: action.error}};

    case 'POST_CUSTOM_SSL_CERTIFICATES_PROCESSING':
      return {...state, ...{processing: action.processing}};

    default: return state;
  }
}